import { render } from "./TheDatePicker.vue?vue&type=template&id=1bfa2bf6"
import script from "./TheDatePicker.vue?vue&type=script&lang=js"
export * from "./TheDatePicker.vue?vue&type=script&lang=js"

import "./TheDatePicker.vue?vue&type=style&index=0&id=1bfa2bf6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__